import React from 'react';
import TextField from '@material-ui/core/TextField';
import { InputAdornment, IconButton } from '@material-ui/core';

import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import { useImmer } from 'use-immer';
import { Heading2 } from '../styled/Heading';

import HelpIcon from '@material-ui/icons/Help';
import { removeSpace } from '../utils/removeSpace';
import { VegSystem } from '../utils/vegfilter';
import { red400 } from '../color';
import { gray100 } from '../color';
import { Either } from 'purify-ts/Either';
import * as R from 'remeda';
import 'twin.macro';

interface VegfilterInput {
  vegsystemInput: string;
  vegsystem: Either<string, VegSystem>;
  updateVegsystem: React.Dispatch<string>;
  variant?: 'standard' | 'filled';
}

export default function SharedVegfilterInput({
  vegsystem,
  vegsystemInput,
  updateVegsystem,
  variant = 'standard',
}: VegfilterInput) {
  const [modal, setModal] = useImmer(false);

  const onVegsystemRefChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitizedVegsystem = R.pipe(e.currentTarget.value, removeSpace);
    updateVegsystem(sanitizedVegsystem);
  };

  function openModal() {
    setModal(() => true);
  }

  function closeModal() {
    setModal(() => false);
  }
  return (
    <div>
      <VegFilterInfoModal modal={modal} closeModal={closeModal} />

      <TextField
        label="Vegfilter"
        tw="w-full"
        variant={variant}
        value={vegsystemInput}
        onChange={onVegsystemRefChange}
        error={vegsystem.isLeft()}
        aria-label="Vegfilter: Definer vegfilter. Klikk for å lese mer"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={openModal} style={{ cursor: 'pointer' }}>
                <HelpIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        helperText={
          vegsystem.isLeft()
            ? R.pipe(
                vegsystem.leftOrDefault(''),
                val => val.split(':')[1],
                val => val + ', separer med flere filter med komma',
              )
            : 'Flere vegfiltre kan angis, separer med komma'
        }
      />
    </div>
  );
}

/**
 * Modalvindu for forklaring av hva et vegfilter er
 */
interface ModalProps {
  modal: boolean;
  closeModal: () => void;
}

function VegFilterInfoModal({ modal, closeModal }: ModalProps) {
  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={modal}
      onClose={closeModal}
    >
      <div
        style={{
          position: 'absolute',
          marginLeft: 'auto',
          marginRight: 'auto',
          left: 0,
          right: 0,
          top: '35%',
          backgroundColor: gray100,
        }}
      >
        <Heading2> Vegfilter</Heading2>
        <article style={{ textAlign: 'center' }}>
          <p>
            Med vegsystemreferanse kan du snevre søket ditt inn til ønsket avgrensing, fra europavegnivå og helt ned til
            meternivå.
          </p>
        </article>
        <div style={{ margin: '3rem 0', textAlign: 'center' }}>
          <Button
            href="https://nvdbapiles-v3.atlas.vegvesen.no/dokumentasjon/#eksempler-p%C3%A5-vegsystemreferanser"
            target="_blank"
            style={{
              marginRight: '2rem',
              backgroundColor: red400,
              color: 'white',
            }}
            variant="contained"
          >
            Les mer på api.vegdata.no
          </Button>
        </div>
        <div style={{ margin: '3rem 0', textAlign: 'center' }}>
          <Button variant="contained" onClick={closeModal}>
            Lukk
          </Button>
        </div>
      </div>
    </Modal>
  );
}
